import * as React from "react";

function UpRightAndDownLeftFromCenterIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m183 295-81.38 81.38-47.03-47.03a31.986 31.986 0 0 0-22.63-9.367c-4.117 0-8.279.809-12.25 2.43a31.985 31.985 0 0 0-19.75 29.56v135.1C.001 501.3 10.75 512 24 512h136c12.94 0 24.63-7.797 29.56-19.75a31.952 31.952 0 0 0-6.938-34.87l-47.03-47.03 81.38-81.38c9.375-9.375 9.375-24.56 0-33.94S192.4 285.7 183 295zM487.1 0h-136c-12.94 0-24.63 7.797-29.56 19.75a31.952 31.952 0 0 0 6.938 34.87l47.04 47.03-81.38 81.38c-9.375 9.375-9.375 24.56 0 33.94s24.56 9.375 33.94 0l81.38-81.38 47.03 47.03a31.986 31.986 0 0 0 22.63 9.35c4.117 0 8.275-.792 12.24-2.413C504.2 184.6 512 172.9 512 159.1v-136C512 10.75 501.3 0 487.1 0z"
  }));
}

const ForwardRef = React.forwardRef(UpRightAndDownLeftFromCenterIcon);
export default ForwardRef;